import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';

// components
import Delete from '@material-ui/icons/Delete';
import CommonButton, { CommonButtonProps } from './CommonButton';
import { dangerTheme } from 'styles/themes';

type Props = Omit<CommonButtonProps, 'label' | 'type'> & {
  label?: CommonButtonProps['label'];
  type?: CommonButtonProps['type'];
};

const DeleteButton = (props: Props): JSX.Element => {
  const label = props.label !== undefined ? props.label : 'Delete';
  const type = props.type !== undefined ? props.type : 'icon';
  return (
    <MuiThemeProvider theme={ dangerTheme }>
      <CommonButton
        { ...props }
        type={ type }
        label={ label }
        icon={ props.icon ?? (type === 'text' ? undefined : <Delete />) }
      />
    </MuiThemeProvider>
  );
};

export default DeleteButton;
